<template>
  <div class="custom-table-responsive">
    <table class="custom-table mb-3" style="width: 100%">
      <!-- <thead>
        <tr>
          <div class="lyon-display-medium-24 mb-2">{{ title }}</div>
        </tr>
      </thead> -->
      <tbody>
        <tr>
          <td width="50%">
            <tr v-for="(field, index) in addressFields" :key="index">
              <td>
                <div class="text-muted regular-16">{{ field.label }}</div>
              </td>
              <td><div class="text-muted regular-16">:</div></td>
              <td>
                <div class="regular-16 ml-2">
                  <span v-if="checkNullAndEmptyValues(field.value)">
                    {{ field.value }}
                  </span>
                  <span v-else> -- </span>
                </div>
              </td>
            </tr>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import mixin from '@/utils/mixin.js'

export default {
  name: "AddressTableSection",
  props: ["title", "addressFields"],
  mixins: [mixin],
};
</script>